'use client';

import { freddyTheme, ListItem } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

type CellProps = {
  children: ReactNode;
  highlightBestValue?: boolean;
  highlightCurrentProduct?: boolean;
};

const Cell = ({
  children,
  highlightBestValue = false,
  highlightCurrentProduct = false
}: CellProps) => (
  <ListItem
    py={200}
    px={300}
    sx={{
      minWidth: '18.5rem',
      ...(highlightBestValue && { backgroundColor: '#e0f6e066' }), // Not available in DS and part of a split test
      ...(highlightCurrentProduct && { backgroundColor: freddyTheme.color.background.secondary })
    }}
  >
    {children}
  </ListItem>
);

export default Cell;
